import React, { CSSProperties } from 'react';

interface JustifyProperties {
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
}

interface AlignItemsProperties {
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'strech';
}

interface AlignContentProperties {
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'strech';
}

interface WrapProperties {
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
}

interface Props
  extends
    JustifyProperties,
    AlignItemsProperties,
    AlignContentProperties,
    WrapProperties {
  column?: boolean;
  className?: string;
  style?: CSSProperties;
  children: React.ReactNode;
}

/**
 * @deprecated Use `Flex` from `antd` instead as it does not need update from our part
 */
function Flex({
  column,
  className,
  style,
  justify,
  alignItems,
  alignContent,
  wrap,
  children,
}: Readonly<Props>) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: column ? 'column' : 'row',
        justifyContent: justify,
        alignItems,
        alignContent,
        flexWrap: wrap,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default Flex;
